<div class="container">
    <h1>Filename: {{attachment.fileName}}</h1>
    <app-aa-spinner [loading]="isLoading"></app-aa-spinner>
    <div id="image"></div>
</div>
